import { render, staticRenderFns } from "./TheseEdit.vue?vue&type=template&id=4428a081&"
import script from "./TheseEdit.vue?vue&type=script&lang=js&"
export * from "./TheseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports